import React from 'react';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { GetStaticProps } from 'next';
import { useLocation } from 'react-use';
import { NextSeo } from 'next-seo';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import CoursePackage from '@/components/English/CoursePackage';

// import CourseFeatures from '@/components/English/CourseFeatures';
import Teachers from '@/components/English/Teachers';
import Blog from '@/components/English/Blog';
import CourseSystem from '@/components/English/CourseSystem';
import VipClass from '@/components/English/VipClass';
import ELA from '@/components/English/ELA';
// import { BLOG_URL } from '@/utils/constants';
// import { BlogPost } from '@/components/Home/home';
import Layout from '@/components/Layout';
import Banner from '@/components/English/Banner';
import CourseFeatures from '@/components/English/CourseFeatures';
import CTA from '@/components/CTA';
import useIsMobile from '@/hooks/useIsMobile';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  // let blogPosts: BlogPost[] = [];
  // try {
  //   // 获取所有类别
  //   const posts = await fetch(`${BLOG_URL}/wp-json/wp/v2/wk_get_blog_posts?lang=${locale}&per_page=3`);
  //   const postsData: BlogPost[] = await posts.json();
  //   blogPosts = postsData;
  // } catch (error) {
  //   console.log('blog err', error);
  // }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['home', 'common', 'english', 'path'])),
      // blogPosts: [...blogPosts],
    },
  };
};

// interface IProps {
//   blogPosts: BlogPost[];
// }

const English = () => {
  const { t } = useTranslation(['english', 'common']);
  const state = useLocation();
  const isMobile = useIsMobile();
  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-英文课程-title'),
          description: t('common:seo-英文课程-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-英文课程-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-英文课程-title')}</title>
        <meta name="description" content={t('common:seo-英文课程-description')} />
        <meta name="keywords" content={t('common:seo-英文课程-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-英文课程-title')}
        />
      </Head>
      {/* banner */}
      <Banner />

      {/* 课程特色 CourseFeatures */}
      <CourseFeatures />

      {/* 师资力量 Teachers */}
      <Teachers />

      {/* 课程体系 */}
      <CourseSystem />

      {/* vip精英课 */}
      <VipClass />

      {/* ELA学员故事 */}
      <ELA />

      {/* 课包 */}
      <CoursePackage />

      {/* 博客 */}
      <Blog title={t('english:英文学科Blog', { br: isMobile ? ' ' : '<br/>' })} />

      <section className="marginModelTop  mb-20 lg:mb-[180px] xl:mb-[240px]">
        <CTA
          blockTitle="步骤之旅-标题"
          steps1name="步骤之旅-步骤-1"
          steps2name="步骤之旅-步骤-2"
          steps3name="步骤之旅-步骤-3"
          useTranslationName="english"
          subject="english"
        />
      </section>
    </>
  );
};

export default English;

English.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
